import axios from "axios";
import * as actionType from "../../../constant/actionType";
/*** GetCompDocsListOfWorkersType Action ***/
export const GetAllComplianceListOfClient = (paramsData) => {
  return (dispatch) => {
    const config = {
      method: "get",
      url: `${actionType.environment_url}/api/admin/provider/GetAllComplianceListOfClient`,
      headers: {
        Authorization: `Bearer ${localStorage.getItem("conserve_authtoken")}`,
      },
      params: paramsData,
    };
    return axios(config)
      .then(function (response) {
        return response.data;
      })
      .catch(function (error) {
        return error;
      });
  };
};
